import { ACTION_TYPES } from "../../actions/purchase/PurchaseActions"

const initialState = {
    list: [],
    OrderDetail: {},
    OrderList: [],
    OrderDocuments: [],
    InvoiceErrors: [],
    platesEvidence: []
}
export const PurchaseReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.CLEAN_USER_PROFILE:
            return {
                ...state,
                list: [],
                OrderDetail: {},
                OrderList: [],
                OrderDocuments: [],
                InvoiceErrors: [],
                platesEvidence: []
            }
        case ACTION_TYPES.FETCH_DASHBOARD:
            return {
                ...state,
                list: [...action.payload]
            }
        case ACTION_TYPES.FETCH_OC_BY_STATUS:
            return {
                ...state,
                OrderList: [...action.payload]
            }
        case ACTION_TYPES.FETCH_ORDER_DETAIL:
            return {
                ...state,
                OrderDetail: action.payload,
                platesEvidence: [...action.payload.evidences]
            }
        case ACTION_TYPES.FETCH_PURCHASE_DOCUMENTS:
            return {
                ...state,
                OrderDocuments: [...action.payload]
            }
        case ACTION_TYPES.FETCH_PURCHASE_INVOICE_ERRORS:
            return {
                ...state,
                InvoiceErrors: [...action.payload]
            }
        case ACTION_TYPES.UPLOAD_EVIDENCE:
            return {
                ...state,
                platesEvidence: [...action.payload]
            }
        case ACTION_TYPES.DELETE_EVIDENCE:
            return {
                ...state,
                platesEvidence: [...action.payload]
            }
        default:
            return state
    }
}